import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import QuickTixLogo from "../../../Images/GX_Logo_White_No_Bg.png";
import { Input, notification } from "antd";
import {
  useVerifyOtpMutation,
  useResendOtpMutation,
} from "../../../Redux/Slices/Accounts/AccountsapiSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setVerification } from "../../../Redux/Slices/registerverificationSlice";
const VerifyAccount = () => {
  const [verifyOtp] = useVerifyOtpMutation();
  const [resendOtp] = useResendOtpMutation();
  const [resendTimer, setResendTimer] = useState(59);
  const [emailCode, setEmailCode] = useState("");
  const location = useLocation();
  const email = new URLSearchParams(location.search).get("email");
  const from = new URLSearchParams(location.search).get("from");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  const handleVerify = async () => {
    try {
      if (!emailCode) {
        notification.error({
          
          message: "Please enter the OTP code!",
        });
        return;
      }
      const response = await verifyOtp({ otp: emailCode, email }).unwrap();
      if (response.success) {
        // notification.success({
          
        //   description: "Account verified successfully!",
        // });
        if (from === "register") {
          // dispatch(setVerification(true));
          notification.success({
            
            message: "Registration successful!",
          });
          navigate("/login"); // Redirect to login
        } else {
          navigate(`/create-new-password?email=${encodeURIComponent(email)}`);
        }
      } else {
        notification.error({
          
          message: "Verification failed!",
        });
      }
    } catch (err) {
      notification.error({
        
        message: "Failed to verify account!",
      });
    }
  };

  const handleResendCode = async () => {
    try {
      const response = await resendOtp({ email }).unwrap();
      if (response.success) {
        notification.success({
          
          message: "OTP resent successfully!",
        });
        setResendTimer(59);
      }
    } catch (err) {
      notification.error({
        
        message: "Failed to resend OTP!",
      });
    }
  };

  const isResendDisabled = resendTimer > 0;

  return (
    <Grid p={5}>
      <Box
        sx={{
          backgroundColor: "black",
          width: "100%",
          height: "80px", // Adjust height as needed
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed", // Use 'fixed' if you want it to stay on scroll
          top: 0,
          left: 0,
        }}
        textAlign="center"
      >
        <img
          src={QuickTixLogo}
          alt="GX Tickets"
          style={{ height: "75px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        />
      </Box>
      <Grid container justifyContent="center" alignItems="left">
        <Grid item xs={11} md={6} lg={4}>
          <Box
            textAlign="center"
            hyphens={"auto"}
            display={"flex"}
            flexDirection={"column"}
            gap={3}
            mt={{xs: 10, sm: 10, md: 10, lg: 10, xl: 15}}
          >
            <Typography variant="h4" gutterBottom sx={{ textAlign: "center"}}>
              Verify Account
            </Typography>
            <Typography variant="body1" gutterBottom>
              Enter the OTP code to verify your account
            </Typography>
            <Typography variant="body2" gutterBottom >
              The OTP Code has been sent to <b>{email}</b>
            </Typography>

            <Box sx={{ textAlign: "left" }}>
              <Typography>Email Verification Code</Typography>
              <Input
                placeholder="Enter the 5-digit OTP code"
                size="large"
                value={emailCode}
                onChange={(e) => setEmailCode(e.target.value)}
              />
            </Box>

            <Typography variant="body2" sx={{ textAlign: "center" }}>
              Didn't receive a code?{" "}
              <Button
                type="button"
                onClick={handleResendCode}
                disabled={isResendDisabled}
              >
                Resend Code
              </Button>
            </Typography>
            <Typography variant="body2" sx={{ textAlign: "center"}}>
              Resend code in{" "}
              {resendTimer < 10 ? `00:0${resendTimer}` : `00:${resendTimer}`}
            </Typography>
            <Box>
              <Button
                variant="outlined"
                sx={{
                  mt: 2,
                  width: "100%",
                  textTransform: "none",
                  backgroundColor: "var(--primary-color)",
                  borderRadius: 20,
                  color: "white",
                  outline: "none",
                  border: "none",
                  "&:hover": {
                    color: "grey",
                    backgroundColor: "white",
                    border:"1px solid black",
                    outline: "none",
                  },
                }}
                onClick={handleVerify}
              >
                Verify Account
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default VerifyAccount;
